import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
    getActiveProducts as getActiveProductsApi
} from "@./helpers/frontend_helper";

export const getActiveProducts = createAsyncThunk("Products/getActiveProducts", async () => {
    try {
		const response = getActiveProductsApi();
        return response;
    } catch (error) {
        return error;
    }
});